export default __webpack_public_path__ + "static/PQPS2-d148f53135d56581c110da23f3c08d1d.png";